import './card';
import { Lit3formBlock, html, icon } from '@Root/lib/lit-3form-block';

import { fetchCart, addToCart } from '@Root/spree/api';
import {
  updateCartIndicator,
  changeProductNameInModal,
  changeProductImageInModal,
} from '@Root/spree/dom';
import {
  useCartConfirmationModal,
  logErrorToSentry,
} from '../../../helpers/helpers';

import '@Root/lib/lit-3form-block/components/cta-button';

import { styles } from './css';
export class DirectProductIndex extends Lit3formBlock {
  static get characterName() {
    return 'direct-product-index';
  }

  static get characterStyles() {
    return [...styles];
  }

  static properties = {
    _searchInput: { type: String },
    _filteredProductsList: { type: Array },
  };

  constructor() {
    super();
    this._searchInput = '';
    this._filteredProductsList = this.productsList;

    this.addEventListener('addToDirectCart', async e => {
      await this.addToDirectCart(e.detail);
    });
  }

  async connectedCallback() {
    super.connectedCallback();

    try {
      await this.setupSpreeData();
    } catch (error) {
      logErrorToSentry(error);
    }
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid direct-product-layout">
          ${this.headerHtml} ${this.productsListHtml} ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get headerHtml() {
    return html`
      <div class="header">
        <h3>Solutions</h3>
        <span class="search-input">
          <form method="get" action="/search" role="search">
            <label for="search-input" class="visually-hidden">
              Search products by name
            </label>
            <input
              type="text"
              placeholder="Search by Name"
              id="search-input"
              name="search-input"
              .value="${this._searchInput || ''}"
              @input="${this.onSearchInputChange}"
            />
            ${icon('search')}
          </form>
        </span>
      </div>
    `;
  }

  get productsListHtml() {
    return html`
      <div class="products-list">
        ${this._filteredProductsList.length
          ? this.filteredProductsListHtml
          : this.noProductsHtml}
      </div>
    `;
  }

  get filteredProductsListHtml() {
    return this._filteredProductsList.map(
      product => html`
        <direct-product-index-card .product="${product}">
        </direct-product-index-card>
      `
    );
  }

  get noProductsHtml() {
    return html`
      <div class="no-results-message">
        <p>
          No solutions found. Contact your project manager if this is an error.
        </p>
      </div>
    `;
  }

  onSearchInputChange(e) {
    this._searchInput = e?.target?.value;
    this._filteredProductsList = this.productsList.filter(product =>
      product.name.toLowerCase().includes(this._searchInput.toLowerCase())
    );
  }

  optionalDetailRow(property, propertyName) {
    if (!property || !propertyName) return html``;
    return html`
      <div class="optional-row-wrapper">
        <span class="optional-row-header">${propertyName}</span>
        <span class="optional-row-value">${property}</span>
      </div>
    `;
  }

  productModalImageUrl(url) {
    return this.imagebossUrl(url, null, '200');
  }

  get productsList() {
    return this.content.direct_products || [];
  }

  async setupSpreeData() {
    if (!this.cart) {
      this.cart = await fetchCart();
      if (this.cart) updateCartIndicator(this.cart.data.attributes.item_count);
    }

    this.requestUpdate();
  }

  async addToDirectCart(details) {
    useCartConfirmationModal();

    const { variantId, quantity, analyticsProductId, product } = details;
    const { image_url, name } = product;

    this.cart = await addToCart({
      variantId,
      quantity,
      analyticsProductId,
    });
    if (this.cart) {
      changeProductNameInModal(name, '');
      changeProductImageInModal(this.productModalImageUrl(image_url));
      updateCartIndicator(this.cart.item_count);
    }
  }
}
DirectProductIndex.defineElement();
